import { convertDateToUTC, DATE_PATTERN_DD_MMM_YYYY_DASH, isArrayNullOrEmpty, lastItemOfArray } from "../../utils/helper";
import { Organisation } from "../organisation/OrganisationModelV2";
import { Person } from "../person/Person";
import { ContractInterface } from "./ContractInterface";
import { ContractPhoto } from "./ContractPhoto";
import { Harvest } from "./Harvest";
import { SaleStatement } from "./SaleStatement";

// Define or import ContractInterface
export class ContractNAM implements ContractInterface {
    contract_id: number;
    status: string;
    market_day: string;
    harvests: Harvest[];
    statement: SaleStatement;
    agent_person?: Person;
    buyer?: Organisation;
    agent?: Organisation;
    party?: string;
    financials?: { net_quantity?: number };
    children_contracts_details?: { statement: SaleStatement }[];

    constructor(data: any = {}) {
        this.contract_id = data.contract_id || '';
        this.status = data.status || '';
        this.market_day = data.market_day || '';
        this.harvests = data.harvests?.map((harvest: any) => Harvest.build(harvest));
        this.statement = SaleStatement.buildForName(data.statement || {});
        this.agent_person = Person.build(data.agent_person);
        this.buyer = Organisation.build(data.buyer);
        this.agent = Organisation.build(data.agent);
        this.party = data.party;
        this.financials = data.financials;
        this.children_contracts_details = data.children_contracts_details?.map((c: any) => ({
            statement: SaleStatement.buildForName(c.statement || {})
        }));
    }
    getType(): string {
        return "NAM";
    }

    static build(d: any): ContractNAM {
        return new ContractNAM(d)
    }

    harvestPhotos(): ContractPhoto[] {
        const harvestNotNull = this.harvests?.filter(h => h.photos)
        return harvestNotNull?.flatMap(h => h.photos).filter((p): p is ContractPhoto => p !== undefined) ?? [];
    }
    receiptPhotos(): ContractPhoto[] {
        const weightPhoto = lastItemOfArray(this.getBuyerSaleStatement()?.photos?.filter(p => p.isWeightReceipt()) ?? [])
        const sortationPhoto = lastItemOfArray(this.getBuyerSaleStatement()?.photos?.filter(p => p.isSortationTicket()) ?? [])
        const res = []
        if (weightPhoto) {
            res.push(weightPhoto)
        }
        if (sortationPhoto) {
            res.push(sortationPhoto)
        }
        return res
    }

    isDelivered(): boolean {
        return !isArrayNullOrEmpty(this.receiptPhotos())
    }

    getTotal(): number | undefined {
        return this.statement?.total
    }
    getHarvest(): Harvest[] {
        return this.harvests
    }
    getMargetDay(): string {
        return convertDateToUTC(this.market_day, DATE_PATTERN_DD_MMM_YYYY_DASH)
    }
    getBuyerSaleStatement(): SaleStatement {
        return this.statement
    }

    getBuyer(): Organisation|undefined {
        return this.buyer
    }
    getPersonTransporter(): Person | undefined {
        return undefined
    }
    getPersonAgent(): Person | undefined {
        return this.agent_person
    }
    getAgent(): Organisation | undefined {
        return this.agent
    }
    getId(): number {
        return this.contract_id
    }
    getStatus(): string {
        return this.status
    }
    getNetQuantity(): number | undefined {
        return this.financials?.net_quantity;
    }
}